function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgRefreshOutlinedIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0c3.744 0 6.9 2.76 7.424 6.432a.5.5 0 1 1-.99.141 6.501 6.501 0 0 0-11.985-2.46l2.116-.594a.5.5 0 0 1 .27.962l-3.2.9a.5.5 0 0 1-.63-.408l-.5-3.4a.5.5 0 1 1 .99-.146l.278 1.89A7.5 7.5 0 0 1 7.499 0Zm0 15A7.501 7.501 0 0 1 .075 8.57a.5.5 0 0 1 .99-.14 6.501 6.501 0 0 0 11.984 2.458l-2.113.594a.5.5 0 1 1-.27-.962l3.148-.886a.498.498 0 0 1 .687.431l.495 3.363a.5.5 0 1 1-.99.145l-.278-1.892a7.5 7.5 0 0 1-6.228 3.32Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgRefreshOutlinedIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgRefreshOutlinedIcon);
export default Memo;